import { isObject } from 'lodash';

export type AdsOptions = {
    vastUrl: string | null;
    frequency: number;
    placement: AdsPlacement;
    debug: boolean;
    ctaText?: string;
    timeout?: number | null;
};

export enum AdsPlacement {
    PreRoll = 'preroll', // Entering a story
    MidRoll = 'midroll', // Between pages
    PostRoll = 'postroll', // Leaving a story
}

const DEFAULT_ADS_OPTIONS: AdsOptions = {
    vastUrl: null,
    frequency: 1,
    placement: AdsPlacement.PreRoll,
    debug: false,
};

const validateVastUrl = (vastUrl: string): boolean => {
    try {
        new URL(vastUrl);
        return true;
    } catch (error) {
        return false;
    }
};
export const sanitizeAdsConfig = (ads: unknown): AdsOptions => {
    if (!isObject(ads)) return DEFAULT_ADS_OPTIONS;
    const vastUrl =
        'vastUrl' in ads &&
        typeof ads.vastUrl === 'string' &&
        validateVastUrl(ads.vastUrl)
            ? ads.vastUrl
            : DEFAULT_ADS_OPTIONS.vastUrl;

    const frequency =
        'frequency' in ads && typeof ads.frequency === 'number'
            ? ads.frequency
            : DEFAULT_ADS_OPTIONS.frequency;

    const ctaText =
        'ctaText' in ads && typeof ads.ctaText === 'string'
            ? ads.ctaText
            : DEFAULT_ADS_OPTIONS.ctaText;

    const placement =
        'placement' in ads &&
        typeof ads.placement === 'string' &&
        Object.values(AdsPlacement).includes(ads.placement as AdsPlacement)
            ? (ads.placement as AdsPlacement)
            : DEFAULT_ADS_OPTIONS.placement;

    const timeout =
        'timeout' in ads &&
        (typeof ads.timeout === 'number' || ads.timeout === null)
            ? ads.timeout
            : undefined;

    const debug =
        'debug' in ads && typeof ads.debug === 'boolean'
            ? ads.debug
            : DEFAULT_ADS_OPTIONS.debug;

    return {
        vastUrl,
        frequency,
        debug,
        placement,
        ctaText,
        timeout,
    };
};
